/* unplugin-vue-components disabled */import { render } from "./LoadingText.vue?vue&type=template&id=4236c508"
import script from "./LoadingText.vue?vue&type=script&lang=js"
export * from "./LoadingText.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__